import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Landing from "@/pages/Landing";
import Booking from "@/pages/Booking";
import PaymentReturn from "@/pages/PaymentReturn";
import Tracking from "@/pages/Tracking";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/reservar" element={<Booking />} />
          <Route path="/pago/exito" element={<PaymentReturn />} />
          <Route path="/seguimiento/:id" element={<Tracking />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<AdminDashboard />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
